import Button from '@mui/material/Button'
import ButtonRow from '~/client/components/ButtonRow'
import CommandForm from '~/client/components/CommandForm'

export default function CreateAppAccount({
  app, disabled, onSubmit, ...props
}){
  return <CommandForm {...{
    ...props,
    disabled,
    formButtons: false,
    command: 'appAccounts.create',
    cancelTo: `/accounts/${app.host}`,
    onSubmit(_, command) {
      if (onSubmit) onSubmit()
      else command.call({ host: app.host })
    },
  }}>{({ disabled }) =>
    <ButtonRow>
      <Button
        disabled={disabled}
        type="submit"
        variant="contained"
        color="success"
        sx={{flexGrow: 1}}
      >Create Account</Button>
    </ButtonRow>
  }</CommandForm>
}
